export type ILoggerCallerWeb =
  | 'ServerErrorInit'
  | 'ServerInfoInit'
  | 'AuthStore'
  | 'FetchService'
  | 'Plugin'

export const sendServerError = (
  errorMessage: string,
  caller?: ILoggerCallerWeb,
) => {
  const error = {
    type: 'sendError',
    errorMessage,
    caller,
  }
  const json = JSON.stringify(error)
  console.log(json)
}

export const alertServerError = (
  errorMessage: string,
  caller?: ILoggerCallerWeb,
) => {
  const error = {
    type: 'alertError',
    errorMessage,
    caller,
  }
  const json = JSON.stringify(error)
  console.log(json)
}

export const sendServerInfo = (message: string, caller?: ILoggerCallerWeb) => {
  const info = {
    type: 'sendInfo',
    message,
    caller,
  }
  const json = JSON.stringify(info)
  console.log(json)
}

export const sendProxyError = (params: ILokiErrorUpdate.Request) => {
  const info = {
    type: 'sendError',
    message: params.errorMessage,
    stack: params.stack,
    route: params.route,
  }
  const json = JSON.stringify(info)
  console.log(json)
}
